/**
 * D10 -- whose ladder is the setup ladder?
 *
 * It sat in EVERYBODY's navigation: the preparer's, the owner's, the
 * reviewer's, the CRO's. It is a list of stations belonging to two
 * seats, so offering it to the other four put a permanent "finish
 * setting up the bank" in the way of people who cannot do a single step
 * on it -- and, worse, implied the bank was unfinished to readers with
 * no way to finish it.
 *
 * The administrator does the plumbing; the resilience lead does the
 * governance stations. Nobody else has a station on it.
 */
export interface LadderViewer {
  is_admin?: boolean;
  realm_roles?: string[];
}

export function setsTheBankUp(me: LadderViewer | undefined): boolean {
  if (!me) return false;
  if (me.is_admin) return true;
  return (me.realm_roles ?? []).includes("head_of_opsres");
}
